// @flow

import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
//import { jsx } from '@emotion/core';
import { ClipLoader } from 'react-spinners';
import queryString from "query-string";
import { login } from "ducks/user/actions";

class LoginAuth extends Component {
  componentDidMount() {
    //console.log('LoginAuth componentDidMount', this.props.user.lang, 'sds', window.location.search)
    //console.log('LoginAdded window.location.search:', window.location.search, 'window:', window, 'props.router:', this.props.router, 'location.search:', this.props.router.location.search)
    if (window.location.search) {
      const { user } = this.props;
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const parsed = queryString.parse(window.location.search);
      //console.log('window.location.search:', window.location.search, ', queryString.parse:', queryString.parse(window.location.search), ', user', user)

      if(/android/i.test(userAgent) && !/wv/i.test(userAgent)) {
        console.log(`go to hedged-bitcoin://app?code=${parsed.code}`)
        document.location.replace(`hedged-bitcoin://app?code=${parsed.code}`)
        setTimeout(() => this.props.login(parsed.code, user.lang.toLowerCase()), 1000)
      } else {
        this.props.login(parsed.code, user.lang.toLowerCase());
      }
    }
  }

  

  render() {
    //console.log('LoginAuth render', this.props.user.lang)
    //const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    //const parsedCode = window.location.search?queryString.parse(window.location.search).code:"no_code"
    return (
      <Fragment>
        {/*
          /android/i.test(userAgent) ?
            <div style={{textAlign: "center"}}>
              <a id="link" href={`hedged-bitcoin://app?code=${parsedCode};scheme=hedged-bitcoin;package=com.hedged_bitcoin;end`} style={{fontSize: "2em", textDecoration: "none", border: "2px solid red", borderRadius: "50%", height: "100px", width: "100px", display: "inline-block", lineHeight: 4.5, textAlign: "center", zIndex: 999}}>Click me</a>
            </div>
          :
            null
        */}
        <div style={{position: "absolute", justifyContent: "center", width: "100%", display: "flex", height: "100%", alignItems: "center"}}>
          <ClipLoader sizeUnit={"px"} size={150} color={'#21ce99'} loading={true} />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps, {login})(LoginAuth);


// WEBPACK FOOTER //
// ./src/containers/auth/loginauth/Login.js